import React, { useEffect, useState } from 'react'
import HeaderCursos from './Components/HeaderCursos'
import AulasInfo from './Components/AulasInfo'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import ProgressoInfo from './Components/ProgressoInfo'
import { useNavigate, useParams } from 'react-router-dom'; 
import './styles.css'
import { useCursosStorage } from '../../storage/cursos'
export default function Cursos() {

    const { id } = useParams();
    const navigate = useNavigate();
    /* const { cursos, cursosEstudante, isMatriculado, selectedCurso } = useUserStorage(state => state) */
    /* const { setIsMatriculado, setSelectedCurso } = useUserStorage(state => state.dispatch) */
    
    const { cursosTotais, cursosDoEstudante, selectedCurso, isMatriculado } = useCursosStorage(state => state).dados
    const { setSelectedCurso, setIsMatriculado } = useCursosStorage(state => state).dispatch

    useEffect(() => { 
        if(cursosTotais?.length === 0){ 
            navigate('/painel')
        }else{ 
            const temCurso = cursosDoEstudante.filter(item=>{
                if(id == item.id){
                    return item
                }
            }) 

            if(temCurso.length === 1){
                setIsMatriculado(true)
                return setSelectedCurso(temCurso[0])
            }else{
                setIsMatriculado(false)
                const curso = cursosTotais.filter(item=>{
                    if(id == item.id){
                        return item
                    }
                })  
                setSelectedCurso(curso[0])
            }
        } 
    }, [])

    return (
        <div>
            <Header />
            <div style={{ padding: '20px 70px', display: 'flex', justifyContent: 'start' }}>

                <HeaderCursos selectedCurso={selectedCurso} />
            </div>
            <div className='cursoDiv'> 
                <div >
                    <AulasInfo selectedCurso={selectedCurso} />
                </div>
                <div>
                    <ProgressoInfo selectedCurso={selectedCurso} isMatriculado={isMatriculado} setIsMatriculado={setIsMatriculado}/>
                </div>
            </div>
            <Footer />
        </div>
    )
}
